import React, { useEffect, useState, useRef } from "react";
import {
  Tabs,
  Heading,
  DateInput,
  NumberInput,
  Text,
  toaster,
  Message,
  Tag,
  Loader,
  Box,
  Col,
  Row,
} from "rsuite";
import {
  Alert,
  Button,
  Form,
  Input,
  Select,
  Card,
  Table as TableAntd,
  Space,
  notification,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import {
  getDatosPaciente,
  getPacientes,
  getNombreDuplicado,
  savePaciente,
} from "../Services/PacientesServices";

import { getDatosCliente, saveCliente } from "../Services/Interfase";

import {
  getFormaciones,
  getEntidades,
  getMunicipios,
  getNaciones,
  getReligiones,
  getRegimenFiscal,
} from "../Services/CatalogosServices";

import {
  FaFileInvoice,
  FaList,
  FaPlusCircle,
  FaSave,
  FaUser,
} from "react-icons/fa";
import { confApp } from "../../CONF_APP";
import moment from "moment/moment";
import { LayoutMain } from "../LayoutMain";

export const Pacientes = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const idUser = JSON.parse(localStorage.getItem("auth")).idUser;
  const [idReq, setIdReq] = useState(0);

  const modalConstimientos = useRef();
  const initialized = useRef(false);

  const fileInputRef = useRef(null);
  const [loaderVisible, setLoaderVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Initial check
  const idMedico = JSON.parse(localStorage.getItem("auth")).idMedico;

  const [disabledDocs, setDisabledDocs] = useState(true);
  const [data, setData] = useState([]);
  const [nuevoPac, setNuevoPac] = useState(false);
  const [modalValida, setModalValida] = useState(false);
  const [documentoAValidar, setDocumentoAValidar] = useState("");
  const [listaVisible, setListaVisible] = useState(true);

  const [filtro, setFiltro] = useState("NULL");
  const [expediente, setExpediente] = useState(false);
  const [listReqs, setListReqs] = useState([]);
  const [listDocsEntreg, setListDocsEntreg] = useState([]);
  const [listEdosMedicos] = useState([
    { label: "Sin estado", value: "" },
    { label: "Positivo", value: "Positivo" },
    { label: "Grave", value: "Grave" },
  ]);
  const [estadoMedIni, setEstadoMedIni] = useState("");
  const [estadoMedActual, setEstadoMedActual] = useState("");
  const [sinDatos, setSinDatos] = useState(0);

  const [modalOpenReqs, setModalOpenReqs] = useState(false);

  const [form] = Form.useForm();
  const [formFac] = Form.useForm();
  const [formLayout] = useState("horizontal");

  // CONSTANTES DATOS DEL PACIENTE
  const [paciente, setPaciente] = useState("");
  const [idPac, setIdPac] = useState(0);
  const [fecNac, setFecNac] = useState("");
  const [listaNacion, setListaNacion] = useState([]);
  const [estado, setEstado] = useState([]);
  const [municipio, setMunicipio] = useState([]);
  const [estadoFisc, setEstadoFisc] = useState([]);
  const [muniFisc, setMuniFisc] = useState([]);
  const [dataNivelEstud, setDataNivEstud] = useState([]);

  const [codPais, setCodPais] = useState(0);
  const [cambioCodPais, setCambioCodPais] = useState(false);
  const [cambioReligion, setCambioReligion] = useState(false);
  const [cambioRegimen, setCambioRegimen] = useState(false);
  const [idReligion, setIdReligion] = useState(0);
  const [cambioEntidad, setCambioEntidad] = useState(false);
  const [idEntidad, setIdEntidad] = useState("00");
  const [cambioFormacion, setCambioFormacion] = useState(false);
  const [idFormacion, setIdFormacion] = useState(0);
  const [cambioMuni, setCambioMuni] = useState(false);
  const [idMuni, setIdMuni] = useState("0");
  const [idEntidadFisc, setIdEntidadFisc] = useState("00");
  const [cambioEntidadFisc, setCambioEntidadFisc] = useState(false);
  const [idMuniFisc, setIdMuniFisc] = useState("0");
  const [cambioMuniFisc, setCambioMuniFisc] = useState(false);
  const [nuevosDatosFac, setNuevosDatosFac] = useState(true);

  const [listReligion, setListReligiones] = useState([]);
  const [listRegimen, setListRegimen] = useState([]);
  const [idRegimen, setIdRegimen] = useState("");
  const [edad, setEdad] = useState(0);

  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const [showMsjDup, setShowMsjDup] = useState(false);
  const [pacientes, setPacientes] = useState(0);
  const [conDocs, setConDocs] = useState(0);
  const [sinDocs, setSinDocs] = useState(0);
  const [verListaBajas, setVerListaBajas] = useState(false);
  const [loadingFac, setLoadingFac] = useState(false);
  const [disbaledFac, setDisabledFac] = useState(false);

  const [idPacienteBaja, setIdPacienteBaja] = useState(0);
  const [pacienteBaja, setPacienteBaja] = useState("");

  const modalBaja = useRef();
  const [api, contextHolder] = notification.useNotification();

  const errorNotificaction = (title, msj) => {
    api.error({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#FFE4E0" } },
      showProgress: true,
    });
  };

  const successNotification = (title, msj) => {
    api.success({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#ECFFE0" } },
      showProgress: true,
    });
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{ padding: 8 }}
        onKeyDown={(e) => e.stopPropagation()}
        tabIndex={"-1"}
      >
        <Input
          ref={searchInput}
          autoFocus
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Resetear
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filtrar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Cerrar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const [listEdoCivil] = useState([
    { label: "", value: "" },
    { label: "Soltero(a)", value: "Soltero(a)" },
    { label: "Casado(a)", value: "Casado(a)" },
    { label: "Divorciado(a)", value: "Divorciado(a)" },
    { label: "Viudo(a)", value: "Viudo(a)" },
    { label: "Union Libre", value: "Union Libre" },
    { label: "Otro", value: "Otro" },
  ]);

  const [listGeneros] = useState([
    { label: "", value: "" },
    { label: "Femenino", value: "Femenino" },
    { label: "Masculino", value: "Masculino" },
    { label: "Otro", value: "Otro" },
  ]);

  const toast = (msg, type = "info") => {
    toaster.push(
      <Message showIcon type={type} closable>
        <strong>{type}!</strong>
        &nbsp; {msg}
      </Message>,
      { duration: 5000, placement: "topCenter" },
    );
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const loadPacientes = async () => {
    if (!filtro) {
      await setFiltro("NULL");
    }
    await getPacientes(idNegocio, filtro)
      .then(async (response) => {
        setData(response);
        setPacientes(response.length);
        setListaVisible(true);
        setVerListaBajas(false);
      })
      .catch((error) => {
        if (error.status === 401) {
          toast("Debe iniciar sesión, antes de continuar...", "error");
          setTimeout(() => {
            window.location = `/`;
          }, 1200);
        } else {
          toast(error.message, "error");
        }
      });
  };

  const getPaciente = async (_idPac) => {
    await getDatosPaciente(idNegocio, _idPac)
      .then(async (response) => {
        await loadCatalogos(false).then(async (next) => {
          setNuevoPac(false);
          setIdPac(_idPac);
          setExpediente(true);

          let _fecha = response.fechaNac;
          if (_fecha !== null) {
            var _fecNac = new Date(response.fechaNac);
            _fecNac.setDate(_fecNac.getDate() + 1);
            calculaEdad(_fecNac);
            setFecNac(_fecNac);
          } else {
            setEdad(0);
            setFecNac(null);
          }

          setCambioCodPais(false);
          setCambioEntidad(false);
          setCambioMuni(false);
          setCambioReligion(false);
          setCambioFormacion(false);

          setPaciente(response.paciente);
          setCodPais(response.codPais);
          setIdEntidad(response.idEntidad);
          setIdMuni(response.idMun);
          setIdFormacion(response.idFormacion);
          setIdReligion(response.idReligion);
          setEstadoMedIni(response.edoMedIni);
          setEstadoMedActual(response.edoMedAct);

          form.setFieldsValue({
            paciente: response.paciente,
            fechaNac: _fecNac,
            telefono: response.telefono,
            correo: response.correo,
            calleNum: response.calleNum,
            colonia: response.colonia,
            codPostal: response.codPostal,
            idEntidad: response.idEntidad,
            idMuni: response.municipio,
            contacto1: response.contacto1,
            relacion1: response.relacion1,
            telContacto1: response.telContacto1,
            contacto2: response.contacto2,
            relacion2: response.relacion2,
            telContacto2: response.telContacto2,
            codPais: response.pais,
            edoCivil: response.edoCivil,
            genero: response.genero === null ? "" : response.genero,
            idFormacion: response.nivelEstud,
            idReligion: response.religion,
          });

          setDisabledDocs(false);
        });
        setLoaderVisible(false);
        // const _result = getAntecedentes(idNegocio, _idPac);
        // setListaAnteced(_result);
        // getExpedientePaciente(_idPac);
      })
      .then(async (res) => {
        // await getDatosCliente(idNegocio, _idPac).then((res) => {
        //   var idEdo = res.EstadoCte;

        //   loadRegimenFiscal(res.RfcCliente).then((res) => {
        //     loadMunicipiosFisc(idEdo);
        //   });

        //   if (res !== "") {
        //     setNuevosDatosFac(false);

        //     setCambioEntidadFisc(false);
        //     setCambioMuniFisc(false);

        //     setIdEntidadFisc(res.IdEntidad);
        //     setIdMuniFisc(res.IdMunicipio);

        //     formFac.setFieldsValue({
        //       razonSocial: res.RazonSocial,
        //       rfc: res.RfcCliente,
        //       direccion: res.DireccCte,
        //       coloniaFiscal: res.ColoniaCte,
        //       cpFiscal: res.CpCte,
        //       idEntidad: res.IdEntidad,
        //       idMunicipio: res.municipio,
        //       emailFisc: res.EmailCte,
        //       cRegimenFiscal: String(res.CRegimenFiscal),
        //     });
        //   }
        // });
        console.log('Pending...');
      })
      .catch((error) => {
        if (error.message === "Network Error") {
          errorNotificaction(
            "Interase Adminsitración",
            "La interfase de adminsitración no se encuentra disponible.",
          );
          setDisabledFac(true);
        } else {
          errorNotificaction(error.name, error.message);
        }
        setLoaderVisible(false);
      });
  };

  const handleOpenModalBaja = (paciente, idPaciente) => {
    setPacienteBaja(paciente);
    setIdPacienteBaja(idPaciente);
    modalBaja.current.open();
  };

  const columns = [
    {
      title: "Paciente",
      dataIndex: "paciente",
      width: "25%",
      key: "paciente",
      ...getColumnSearchProps("paciente"),
      sorter: (a, b) => a.paciente.length - b.paciente.length,
      sortDirections: ["descend", "ascend"],
      render: (text, record) => (
        <Button
          type="text"
          onClick={(e) => {
            e.stopPropagation();
            showExpediente({
              idPaciente: record.idPaciente,
            });
          }}
          style={{ color: "blue" }}
        >
          {text}
        </Button>
      ),
    },
    {
      title: "Estado",
      dataIndex: "estatus",
      width: "5%",
      key: "estatus",
      align: "center",
      sorter: (a, b) => a.estatus.length - b.estatus.length,
      sortDirections: ["descend", "ascend"],
      render: (text) =>
        text === "Incompletos" ? (
          <Tag color="red">Inactivo</Tag>
        ) : (
          <Tag color="green">Activo</Tag>
        ),
    },
    {
      title: "Teléfono",
      dataIndex: "telefono",
      key: "telefono",
      width: "10%",
      align: "center",
      ...getColumnSearchProps("telefono"),
    },
    {
      title: "Contacto",
      dataIndex: "contacto1",
      key: "contacto1",
      width: "25%",
      ...getColumnSearchProps("contacto1"),
    },
    {
      title: "Tel. Contacto",
      dataIndex: "telContacto1",
      key: "telContacto1",
      with: "10%",
      align: "center",
      ...getColumnSearchProps("telContacto1"),
    },
    {
      title: "Citas",
      dataIndex: "citas",
      key: "citas",
      width: "8%",
      align: "center",
    },
    {
      title: "Consultas",
      dataIndex: "sesiones",
      key: "sesiones",
      width: "8%",
      align: "center",
    },
  ];

  const cleanForm = () => {
    setDisabledDocs(true);
    setListDocsEntreg([]);
    form.resetFields();
  };

  const save = async (values) => {
    if (!nuevoPac && !cambioCodPais) {
      values.codPais = codPais;
    }
    if (!nuevoPac && !cambioEntidad) {
      values.idEntidad = idEntidad;
    }
    if (!nuevoPac && !cambioMuni) {
      values.idMuni = idMuni;
    }
    if (!nuevoPac && !cambioFormacion) {
      values.idFormacion = idFormacion;
    }
    if (!nuevoPac && !cambioReligion) {
      values.idReligion = idReligion;
    }

    const newObj = { ...values, id: idNegocio, idPaciente: idPac };

    await savePaciente(newObj).then(async (nxt) => {
      if (nxt.data > 0) {
        setPaciente(values.paciente);
        setIdPac(nxt.data);
        setDisabledDocs(false);
        toast("Los datos se han actualizado de forma correcta.", "success");
      }
    });
  };

  const saveDatosFac = async (values) => {
    if (!nuevosDatosFac && !cambioEntidadFisc) {
      values.idEntidad = idEntidadFisc;
    }
    if (!nuevosDatosFac && !cambioMuniFisc) {
      values.idMunicipio = idMuniFisc;
    }

    setLoadingFac(true);

    const newObj = {
      ...values,
      id: idNegocio,
      nomCortoCte: paciente,
      idPaciente: idPac,
    };

    await saveCliente(newObj)
      .then(async (nxt) => {
        if (nxt.data > 0) {
          toast("Los datos se han actualizado de forma correcta.", "success");
          setLoadingFac(false);
        } else {
          setLoadingFac(false);
          errorNotificaction("Error", "Ocurrio un error");
        }
      })
      .catch((error) => {
        setLoadingFac(false);
        errorNotificaction("Error", error.message);
      });
  };

  const calculaEdad = (e) => {
    const hoy = new Date(); // Fecha actual
    const fechaNac = new Date(e); // Fecha de nacimiento del input

    let edad = hoy.getFullYear() - fechaNac.getFullYear(); // Diferencia de años inicial

    const mesActual = hoy.getMonth();
    const mesNac = fechaNac.getMonth();

    // Si el mes actual es menor que el mes de nacimiento, no ha cumplido años
    if (mesActual < mesNac) {
      edad--;
    } else if (mesActual === mesNac) {
      // Si los meses son iguales, revisamos el día
      const diaActual = hoy.getDate();
      const diaNac = fechaNac.getDate();
      if (diaActual < diaNac) {
        edad--; // No ha cumplido años aún en el mes actual
      }
    }

    // Para obtener meses y días exactos (más complejo, pero posible)
    // Se puede calcular la diferencia en milisegundos y convertir, o iterar meses/días
    // El método anterior solo da los años cumplidos.
    setEdad(edad);
  };

  const handleFechaNac = (e) => {
    var esFecha = moment(e, "DD/MM/YYYY").isValid();
    if (esFecha) {
      var fec = new Date(e).toISOString();
      var fecha = moment(fec).format("DD/MM/YYYY");
      setFecNac(fecha);

      const hoy = new Date(); // Fecha actual
      const fechaNac = new Date(e); // Fecha de nacimiento del input

      let edad = hoy.getFullYear() - fechaNac.getFullYear(); // Diferencia de años inicial

      const mesActual = hoy.getMonth();
      const mesNac = fechaNac.getMonth();

      // Si el mes actual es menor que el mes de nacimiento, no ha cumplido años
      if (mesActual < mesNac) {
        edad--;
      } else if (mesActual === mesNac) {
        // Si los meses son iguales, revisamos el día
        const diaActual = hoy.getDate();
        const diaNac = fechaNac.getDate();
        if (diaActual < diaNac) {
          edad--; // No ha cumplido años aún en el mes actual
        }
      }

      // Para obtener meses y días exactos (más complejo, pero posible)
      // Se puede calcular la diferencia en milisegundos y convertir, o iterar meses/días
      // El método anterior solo da los años cumplidos.
      setEdad(edad);
    }
  };

  const showExpediente = async (props) => {
    setLoaderVisible(true);
    setListaVisible(false);
    setVerListaBajas(false);

    setTimeout(() => {
      getPaciente(props.idPaciente);
    }, 500);
  };

  const loadRegimenFiscal = async (rfc) => {
    if (rfc === undefined) {
      setListRegimen([]);
      return;
    }
    if (rfc.length > 11) {
      await getRegimenFiscal(rfc).then((res) => {
        setListRegimen(res);
      });
    }
  };

  const loadCatalogos = async (esNuevo) => {
    setListaVisible(false);
    setNuevoPac(esNuevo);
    setIdPac(0);
    setPaciente("Nuevo");
    cleanForm();
    setFecNac("");
    setEdad(0);
    setCambioCodPais(false);
    setCambioEntidad(false);
    setCambioMuni(false);
    setCambioReligion(false);
    setCambioFormacion(false);

    await getEntidades().then(async (nxt) => {
      setEstado(nxt);
      setEstadoFisc(nxt);
      await getNaciones().then(async (res) => {
        setListaNacion(res);
        await getFormaciones().then(async (res) => {
          setDataNivEstud(res);
          await getReligiones().then(async (res) => {
            setListReligiones(res);
          });
        });
      });
    });
  };

  const handleCloseModalValida = () => {
    setModalValida(false);
  };

  const openModalValida = (props) => {
    setModalValida(true);
    setIdReq(props.idReq);
    setDocumentoAValidar(props.documento);
  };

  const loadMunicipios = async (e) => {
    setCambioEntidad(true);
    const result = await getMunicipios(e);
    setMunicipio(result);
  };

  const loadMunicipiosFisc = async (e) => {
    setCambioEntidadFisc(true);
    const result = await getMunicipios(e);
    setMuniFisc(result);
  };

  const validateMessages = {
    required: "* Obligatorio",
    types: {
      email: "* El campo de correo no es valido",
      number: "* El campo no es un número!",
    },
  };

  const handleValidaDup = async (e) => {
    // Access the value directly from the event target
    const finalValue = e.target.value;
    await getNombreDuplicado(idNegocio, finalValue)
      .then((res) => {
        if (res !== "") {
          setShowMsjDup(true);
        } else {
          setShowMsjDup(false);
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const handleCloseModalReqs = () => {
    setModalOpenReqs(false);
  };

  const habilitaBoton = (estatus, documento) => {
    let deshabilitado = true;

    if (estatus === "SIN VALIDAR" && documento !== "") {
      deshabilitado = false;
    }
    if (estatus === "VALLIDADO") {
      deshabilitado = true;
    }
    if (estatus === "NO APLICA" && documento !== "") {
      deshabilitado = false;
    }

    return deshabilitado;
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Update on resize
    };
    window.addEventListener("resize", handleResize);
    if (!initialized.current) {
      initialized.current = true;
      loadPacientes();
    }
    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <LayoutMain titleItem={"Pacientes"}>
        <title>Pacientes</title>
        {contextHolder}
        <Form layout={formLayout}>
          <div className="row mb-2">
            <div className="col-lg-3 col-md-3">
              <Button
                block
                type="primary"
                icon={<FaList></FaList>}
                onClick={() => loadPacientes()}
              >
                Lista de pacientes
              </Button>
            </div>
            &nbsp;
            <div className="col-lg-3 col-md-3 col-sm-3">
              <Button
                block
                type="primary"
                icon={<FaPlusCircle></FaPlusCircle>}
                onClick={() => loadCatalogos(true)}
              >
                Nuevo paciente
              </Button>
            </div>
          </div>
        </Form>
        {listaVisible ? (
          <div className="p-4 max-w mx-auto bg-white rounded-xl shadow-md border border-gray-100">
            <div className="row">
              <div className="col">
                <TableAntd
                  bordered
                  size="small"
                  rowKey={(record) => record.idPaciente}
                  columns={columns}
                  dataSource={data}
                  pagination={{ pageSize: 10 }}
                />
              </div>
            </div>
            {isMobile ? (
              ""
            ) : (
              <Row gutter={10} padding={"10px"}>
                <Col span={24} style={{ textAlign: 'center'}}>
                  <Box
                    bd="1px solid var(--rs-border-primary)"
                    rounded="lg"
                    p={10}
                    style={{ textAlign: "center" }}
                  >
                    <Text size={"lg"} color={"black"}>
                      Total de pacientes: {pacientes}
                    </Text>
                  </Box>
                </Col>
              </Row>
            )}
          </div>
        ) : expediente || nuevoPac ? (
          <>
            {loaderVisible ? (
              <>
                <br></br>
                <center>
                  <Loader content="Cargando..." size="lg" />
                </center>
              </>
            ) : (
              <>
                <center style={{ padding: "5px" }}>
                  <Heading
                    level={isMobile ? 9 : 5}
                    style={{
                      fontFamily: "Arial Narrow",
                      backgroundColor: "#F0F0F0",
                      padding: "5px",
                      borderRadius: "7px",
                    }}
                  >
                    Paciente: {paciente}
                  </Heading>
                </center>
                <Tabs
                  defaultActiveKey="1"
                  bordered
                  appearance={isMobile ? "subtle" : "tabs"}
                  style={{ fontSize: isMobile ? "12px" : "16px" }}
                >
                  {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> TAB DATOS GENERALES <<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
                  <Tabs.Tab
                    eventKey="1"
                    title={isMobile ? <FaUser></FaUser> : "Datos Generales"}
                  >
                    <Card>
                      <Form
                        name="basic"
                        form={form}
                        layout="vertical"
                        variant="outlined"
                        initialValues={{ remember: true }}
                        onFinish={save}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                        validateMessages={validateMessages}
                      >
                        <div className="row">
                          <div className="col-lg-3 col-md-3 col-sm-3">
                            <Form.Item
                              name="paciente"
                              label={"Nombre completo"}
                              rules={[{ required: true }]}
                            >
                              <Input onBlur={(e) => handleValidaDup(e)} />
                            </Form.Item>
                          </div>
                          <div className="col-lg-2 col-md-2 col-sm-2">
                            <Form.Item
                              name="fechaNac"
                              label={"Fecha de nacimiento"}
                              rules={[{ required: true }]}
                            >
                              <DateInput
                                format="dd/MM/yyyy"
                                defaultValue={fecNac}
                                onChange={(e) => handleFechaNac(e)}
                              />
                            </Form.Item>
                          </div>

                          <div className="col-lg-1 col-md-1 col-sm-1">
                            <Form.Item label={"Edad"}>
                              <Input
                                readOnly
                                value={edad}
                                style={{ textAlign: "center" }}
                              />
                            </Form.Item>
                          </div>
                          <div className="col-lg-2 col-md-2 col-sm-2">
                            <Form.Item
                              name="telefono"
                              label={"Teléfono"}
                              rules={[{ required: true }]}
                            >
                              <NumberInput
                                controls={false}
                                id="telefono"
                                maxLength={10}
                                min={0}
                              />
                            </Form.Item>
                          </div>
                          <div className="col-lg-4 col-md-4 col-sm-4">
                            <Form.Item
                              label="Correo"
                              name={"correo"}
                              rules={[
                                {
                                  type: "email",
                                  message:
                                    "* No es un formato valido de correo",
                                },
                              ]}
                            >
                              <Input />
                            </Form.Item>
                          </div>
                        </div>
                        {showMsjDup ? (
                          <div className="row mb-2">
                            <Alert
                              title="El nombre del paciente se ha encontrado en la base, revisa que no exista..."
                              type="warning"
                              showIcon
                              closable
                            />
                          </div>
                        ) : (
                          ""
                        )}

                        <div className="row">
                          <div className="col-lg-3 col-md-3 col-sm-3">
                            <Form.Item
                              label="Calle y número"
                              name={"calleNum"}
                              rules={[{ required: true }]}
                            >
                              <Input autoComplete="off" />
                            </Form.Item>
                          </div>
                          <div className="col-lg-2 col-md-2 col-sm-2">
                            <Form.Item
                              label="Colonia"
                              name={"colonia"}
                              rules={[{ required: true }]}
                            >
                              <Input />
                            </Form.Item>
                          </div>
                          <div className="col-lg-1 col-md-1 col-sm-1">
                            <Form.Item
                              label="CP"
                              name={"codPostal"}
                              rules={[{ required: true }]}
                            >
                              <Input maxLength={5} />
                            </Form.Item>
                          </div>
                          <div className="col-lg-3 col-md-3 col-sm-3">
                            <Form.Item
                              label="Estado"
                              name={"idEntidad"}
                              rules={[{ required: true }]}
                            >
                              <Select
                                options={estado}
                                onChange={(e) => loadMunicipios(e)}
                                showSearch={{
                                  optionFilterProp: "label",
                                  filterSort: (optionA, optionB) =>
                                    (optionA?.label ?? "")
                                      .toLowerCase()
                                      .localeCompare(
                                        (optionB?.label ?? "").toLowerCase(),
                                      ),
                                }}
                                autoComplete="off"
                              />
                            </Form.Item>
                          </div>
                          <div className="col-lg-3 col-md-3 col-sm-3">
                            <Form.Item
                              label="Municipio"
                              name={"idMuni"}
                              rules={[{ required: true }]}
                            >
                              <Select
                                options={municipio}
                                showSearch={{
                                  optionFilterProp: "label",
                                  filterSort: (optionA, optionB) =>
                                    (optionA?.label ?? "")
                                      .toLowerCase()
                                      .localeCompare(
                                        (optionB?.label ?? "").toLowerCase(),
                                      ),
                                }}
                                onChange={() => setCambioMuni(true)}
                                autoComplete="off"
                              />
                            </Form.Item>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-3 col-md-3 col-sm-3">
                            <Form.Item
                              label="Contacto(1)"
                              name={"contacto1"}
                              rules={[{ required: true }]}
                            >
                              <Input />
                            </Form.Item>
                          </div>
                          <div className="col-lg-2 col-md-2 col-sm-2">
                            <Form.Item
                              label="Parentesco (1)"
                              name={"relacion1"}
                              rules={[{ required: true }]}
                            >
                              <Select
                                style={{ width: "100%" }}
                                options={confApp.RELACIONES}
                                block
                              />
                            </Form.Item>
                          </div>
                          <div className="col-lg-1 col-md-1 col-sm-1">
                            <Form.Item
                              label="Teléfono"
                              name={"telContacto1"}
                              rules={[{ required: true }]}
                            >
                              <Input maxLength={10} />
                            </Form.Item>
                          </div>

                          <div className="col-lg-3 col-md-3 col-sm-3">
                            <Form.Item label="Contacto(2)" name={"contacto2"}>
                              <Input />
                            </Form.Item>
                          </div>
                          <div className="col-lg-2 col-md-2 col-sm-2">
                            <Form.Item
                              label="Parentesco (2)"
                              name={"relacion2"}
                            >
                              <Select
                                style={{ width: "100%" }}
                                options={confApp.RELACIONES}
                                block
                              />
                            </Form.Item>
                          </div>
                          <div className="col-lg-1 col-md-1 col-sm-1">
                            <Form.Item label="Teléfono" name={"telContacto2"}>
                              <Input maxLength={10} />
                            </Form.Item>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-2 col-md-2 col-sm-2">
                            <Form.Item
                              label="Nacionalidad"
                              name={"codPais"}
                              rules={[{ required: true }]}
                            >
                              <Select
                                autoComplete="off"
                                options={listaNacion}
                                showSearch={{
                                  optionFilterProp: "label",
                                  filterSort: (optionA, optionB) =>
                                    (optionA?.label ?? "")
                                      .toLowerCase()
                                      .localeCompare(
                                        (optionB?.label ?? "").toLowerCase(),
                                      ),
                                }}
                                onChange={() => setCambioCodPais(true)}
                              />
                            </Form.Item>
                          </div>
                          <div className="col-lg-2 col-md-2 col-sm-2">
                            <Form.Item label="Estado Civil" name={"edoCivil"}>
                              <Select options={listEdoCivil} />
                            </Form.Item>
                          </div>
                          <div className="col-lg-1 col-md-1 col-sm-1">
                            <Form.Item label="Genero" name={"genero"}>
                              <Select options={listGeneros} />
                            </Form.Item>
                          </div>
                          <div className="col-lg-4 col-md-4 col-sm-4">
                            <Form.Item
                              label="Formación académica"
                              name={"idFormacion"}
                              rules={[{ required: true }]}
                            >
                              <Select
                                options={dataNivelEstud}
                                showSearch={{
                                  optionFilterProp: "label",
                                  filterSort: (optionA, optionB) =>
                                    (optionA?.label ?? "")
                                      .toLowerCase()
                                      .localeCompare(
                                        (optionB?.label ?? "").toLowerCase(),
                                      ),
                                }}
                                onChange={() => setCambioFormacion(true)}
                              />
                            </Form.Item>
                          </div>
                          <div className="col-lg-3 col-md-3 col-sm-3">
                            <Form.Item
                              label="Religión"
                              name={"idReligion"}
                              rules={[{ required: true }]}
                            >
                              <Select
                                options={listReligion}
                                showSearch={{
                                  optionFilterProp: "label",
                                  filterSort: (optionA, optionB) =>
                                    (optionA?.label ?? "")
                                      .toLowerCase()
                                      .localeCompare(
                                        (optionB?.label ?? "").toLowerCase(),
                                      ),
                                }}
                                onChange={() => setCambioReligion(true)}
                              />
                            </Form.Item>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col">
                            <br></br>
                            <Button
                              icon={<FaSave></FaSave>}
                              type="primary"
                              htmlType="submit"
                              block
                            >
                              Guardar
                            </Button>
                          </div>
                        </div>
                      </Form>
                    </Card>
                  </Tabs.Tab>

                  {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> DATOS DE FACTURACIÓN <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
                  <Tabs.Tab
                    eventKey="6"
                    title={
                      isMobile ? (
                        <FaFileInvoice></FaFileInvoice>
                      ) : (
                        "Datos de Facturación"
                      )
                    }
                    disabled={true}
                  >
                    <Card>
                      <Form
                        name="basic"
                        form={formFac}
                        layout="vertical"
                        variant="outlined"
                        initialValues={{ remember: true }}
                        onFinish={saveDatosFac}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                        validateMessages={validateMessages}
                      >
                        <div className="row mb-1">
                          <div className="col-lg-4 col-md-4 col-sm-4">
                            <Form.Item
                              name="razonSocial"
                              label={"Razón Social"}
                              rules={[{ required: true }]}
                            >
                              <Input style={{ textTransform: "uppercase" }} />
                            </Form.Item>
                          </div>
                          <div className="col-lg-2 col-md-2 col-sm-2">
                            <Form.Item
                              name="rfc"
                              label={"RFC"}
                              rules={[{ required: true }]}
                            >
                              <Input
                                style={{
                                  textAlign: "center",
                                  textTransform: "uppercase",
                                }}
                                onChange={(e) =>
                                  loadRegimenFiscal(e.target.value)
                                }
                              />
                            </Form.Item>
                          </div>
                          <div className="col-lg-3 col-md-3 col-sm-3">
                            <Form.Item
                              name="direccion"
                              label={"Dirección (Calle y Número)"}
                              rules={[{ required: true }]}
                            >
                              <Input style={{ textTransform: "uppercase" }} />
                            </Form.Item>
                          </div>
                          <div className="col-lg-3 col-md-3 col-sm-3">
                            <Form.Item
                              name="coloniaFiscal"
                              label={"Colonia"}
                              rules={[{ required: true }]}
                            >
                              <Input style={{ textTransform: "uppercase" }} />
                            </Form.Item>
                          </div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-lg-1 col-md-1 col-sm-1">
                            <Form.Item
                              name="cpFiscal"
                              label={"CP"}
                              rules={[{ required: true }]}
                            >
                              <Input
                                style={{ textAlign: "center" }}
                                maxLength={5}
                              />
                            </Form.Item>
                          </div>
                          <div className="col-lg-3 col-md-3 col-sm-3">
                            <Form.Item
                              label="Estado"
                              name={"idEntidad"}
                              rules={[{ required: true }]}
                            >
                              <Select
                                options={estadoFisc}
                                onChange={(e) => loadMunicipiosFisc(e)}
                                showSearch={{
                                  optionFilterProp: "label",
                                  filterSort: (optionA, optionB) =>
                                    (optionA?.label ?? "")
                                      .toLowerCase()
                                      .localeCompare(
                                        (optionB?.label ?? "").toLowerCase(),
                                      ),
                                }}
                                autoComplete="off"
                              />
                            </Form.Item>
                          </div>
                          <div className="col-lg-3 col-md-3 col-sm-3">
                            <Form.Item
                              label="Municipio"
                              name={"idMunicipio"}
                              rules={[{ required: true }]}
                            >
                              <Select
                                options={muniFisc}
                                showSearch={{
                                  optionFilterProp: "label",
                                  filterSort: (optionA, optionB) =>
                                    (optionA?.label ?? "")
                                      .toLowerCase()
                                      .localeCompare(
                                        (optionB?.label ?? "").toLowerCase(),
                                      ),
                                }}
                                onChange={() => setCambioMuniFisc(true)}
                                autoComplete="off"
                              />
                            </Form.Item>
                          </div>
                          <div className="col-lg-5 col-md-5 col-sm-5">
                            <Form.Item
                              label="Correo"
                              name={"emailFisc"}
                              rules={[
                                {
                                  type: "email",
                                  message:
                                    "* No es un formato valido de correo",
                                },
                              ]}
                            >
                              <Input />
                            </Form.Item>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-4 col-md-4 col-sm-4">
                            <Form.Item
                              label="Régimen Fiscal"
                              name={"cRegimenFiscal"}
                              rules={[{ required: true }]}
                            >
                              <Select
                                options={listRegimen}
                                showSearch={{
                                  optionFilterProp: "label",
                                  filterSort: (optionA, optionB) =>
                                    (optionA?.label ?? "")
                                      .toLowerCase()
                                      .localeCompare(
                                        (optionB?.label ?? "").toLowerCase(),
                                      ),
                                }}
                                onChange={() => setCambioRegimen(true)}
                              />
                            </Form.Item>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col">
                            <br></br>
                            <Button
                              disabled={disbaledFac}
                              icon={<FaSave></FaSave>}
                              type="primary"
                              htmlType="submit"
                              block
                              loading={loadingFac}
                            >
                              Guardar
                            </Button>
                          </div>
                        </div>
                      </Form>
                    </Card>
                  </Tabs.Tab>
                </Tabs>
              </>
            )}
          </>
        ) : (
          ""
        )}
      </LayoutMain>
    </div>
  );
};
